export default "__VITE_ASSET__8522eb8f__"